import React from "react";
import { FormattedMessage } from "react-intl";
import { useFormatMessage } from "../../utils/functions";

interface ToggleFilterButtonProps {
  activeFilters: string[];
  buttonContainerStyle: string;
  buttonStyle: string;
  filterDivToggleId: string;
  amount?: number;
  toggle: (id: string) => void;
}

export const ToggleFilterButton: React.FC<ToggleFilterButtonProps> = ({
  toggle,
  activeFilters,
  amount,
  buttonContainerStyle,
  buttonStyle,
  filterDivToggleId,
}) => {
  const noFilters = useFormatMessage("Table.SearchBar.Button.Filter");
  const multiFilters = useFormatMessage("Table.SearchBar.Button.MultiFilter");

  const buttonlabel =
    amount === 1 ? (
      `${activeFilters[0]}`
    ) : amount === 0 ? (
      <FormattedMessage id={noFilters} defaultMessage='Filter' />
    ) : (
      <FormattedMessage
        id={multiFilters}
        values={{ amount: amount }}
        defaultMessage={`Filters: ${amount}`}
      />
    );

  const buttonColor =
    amount > 0 ? `bg-blue-800 text-white` : `bg-blue-400 text-white`;

  return (
    <div className={`${buttonContainerStyle} ${buttonColor}`}>
      <button
        className={`${buttonStyle} truncate`}
        onClick={() => toggle(filterDivToggleId)}
      >
        {buttonlabel}
      </button>
    </div>
  );
};
